/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { HostComponent, Router } from 'llama'

import FaceConfig from '../../common/FaceConfig.js'
import FaceDrawer from '../../common/FaceDrawer.js'

import * as onboardingCss from 'bundle-text:./onboarding-face.css'
import OnboardingRoutes from '../OnboardingRoutes.js'
import FacePortrait from './FacePortrait.js'
import OnboardingFooter from './OnboardingFooter.js'
import ApiClient from '../api-client.js'

export default class OnboardingFace extends HostComponent {
  constructor (opt) {
    super({
      ...opt,
      css: [onboardingCss],
      html: ({ zoom }) => `<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
          <div>
            <button id="onboarding-change-face" title="${this.context.onboarding.facerandom}">&#x27F2</button>
            <button id="onboarding-full-size" type="checkbox" title="${this.context.onboarding.fullsize}">${zoom === 'portrait' ? '&#x1F9CD' : '&#x1F464'}</button>
          </div>
        </div>
        <div id="onboarding-choose-part">
          <canvas id="onboarding-appearance-contour" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-eye" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-nose-mouth" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-hair" width="48" height="48"></canvas>
          <canvas id="onboarding-appearance-body" width="48" height="48"></canvas>
        </div>
        <div id="onboarding-part-sub"></div>
        <div id="onboarding-footer"></div>
      </div>`
    })

    this.faceDrawer = new FaceDrawer()
  }

  init (params, path) {
    this.zoom = params.zoom

    const { eventBus, context } = this
    this.addChildren(
      params, path,
      new FacePortrait({
        eventBus,
        context,
        box: 'onboarding-portrait'
      }),
      new OnboardingFooter({
        eventBus,
        context,
        box: 'onboarding-footer',
        next: (config) => {
          this.emit(Router.GO, OnboardingRoutes.Name())
        }
      })
    )

    this.initConfig(params, path)
    this.initCanvasButton()

    this.on(Router.LAND, (params, path) => {
      this.initConfig(params, path, () => {
        this.gId('onboarding-full-size').innerHTML = this.zoom === 'portrait' ? '&#x1F9CD' : '&#x1F464'
        this.initCanvasButton()
      })
    })

    this.addEvtById('onboarding-change-face', 'click', () => {
      this.emit(FaceConfig.UPDATE, FaceConfig.changes(), (faceConfig) => this.emit(ApiClient.UPDATE_DATA, { faceConfig }))
    })

    this.addEvtById('onboarding-full-size', 'click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom === 'portrait' ? OnboardingRoutes.Full : OnboardingRoutes.Portrait, this.part))
    })
  }

  initConfig (params, path, cb = () => {}) {
    const splitPath = OnboardingRoutes.FaceSplit(path)
    if (splitPath) {
      const { part } = splitPath
      this.config = FaceConfig.get()
      this.zoom = params.zoom
      this.part = part
      cb()
    }
  }

  initCanvasButton () {
    const contourBtn = this.gId('onboarding-appearance-contour')
    this.faceDrawer.drawNoHairFace(contourBtn.getContext('2d'), 1, 0.5, 0)

    contourBtn.addEventListener('click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom, OnboardingRoutes.Head))
    })

    if (this.part === OnboardingRoutes.Head) contourBtn.classList.add('selected')
    else contourBtn.classList.remove('selected')

    const eyeBtn = this.gId('onboarding-appearance-eye')
    const eyeCTx = eyeBtn.getContext('2d')
    this.faceDrawer.drawEyes(eyeCTx, 1, 0.8, 5, { left: -15, top: 20 })
    this.faceDrawer.drawEyebrows(eyeCTx, 1, 0.8, 5, { left: -15, top: 10 })

    eyeBtn.addEventListener('click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom, OnboardingRoutes.Eyes))
    })

    if (this.part === OnboardingRoutes.Eyes) eyeBtn.classList.add('selected')
    else eyeBtn.classList.remove('selected')

    const noseMouthBtn = this.gId('onboarding-appearance-nose-mouth')
    const noseMouthCtx = noseMouthBtn.getContext('2d')
    this.faceDrawer.drawNose(noseMouthCtx, 1, 1, 15, -25)
    this.faceDrawer.drawMouth(noseMouthCtx, 1, 1, 35, -25)

    noseMouthBtn.addEventListener('click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom, OnboardingRoutes.NoseMouth))
    })

    if (this.part === OnboardingRoutes.NoseMouth) noseMouthBtn.classList.add('selected')
    else noseMouthBtn.classList.remove('selected')

    const hairBtn = this.gId('onboarding-appearance-hair')
    this.faceDrawer.drawHairOnly(hairBtn.getContext('2d'), 2, 0.5, 10, { left: -1, top: 0 })

    hairBtn.addEventListener('click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom, OnboardingRoutes.Hair))
    })

    if (this.part === OnboardingRoutes.Hair) hairBtn.classList.add('selected')
    else hairBtn.classList.remove('selected')

    const bodyBtn = this.gId('onboarding-appearance-body')
    this.faceDrawer.drawBodyOnly(bodyBtn.getContext('2d'), 1, 0.1, { left: 18, top: -5 })

    bodyBtn.addEventListener('click', () => {
      this.emit(Router.GO, OnboardingRoutes.Face(this.zoom, OnboardingRoutes.Body))
    })

    if (this.part === OnboardingRoutes.Body) bodyBtn.classList.add('selected')
    else bodyBtn.classList.remove('selected')
  }
}
